import React, { useEffect } from 'react'
import { Navigate, Outlet, NavLink } from "react-router-dom";
import { useSelector } from 'react-redux'

import socket from '../app/socket'

export const ProtectedLayout = () => {
  //console.log('[ProtectedLayout]')
  const bc_token = localStorage.getItem('bc_token')
  const token = (bc_token === 'null' || bc_token === undefined)
    ? null
    : bc_token
  const user = useSelector((state) => state.auth.user)
  //console.log('[ProtectedLayout] token =', token, 'user =', user);

  useEffect(() => {
    if (user && token) {
      // CONNECT TO WEBSOCKET
      socket.auth = { token }
      socket.connect()
    }
  }, [user, token])

  if (!user && !token) {
    if (window.location.pathname.includes('rooms') || window.location.pathname.includes('settings')) {

      //console.log('url =', window.location.toString())
      const params = (new URL(document.location)).searchParams
      //console.log('params.get(to) =', params.get('to'))
      const to = params.get('to') || '/login'
      //console.log('to =', to)
      if (params.has('email')) {
        localStorage.setItem('email', params.get('email'))
      }
      //console.log('window.location.pathname =', window.location.pathname)
      localStorage.setItem('next', window.location.pathname)
      return <Navigate to={to} />
    }
    else {
      return
    }
  }

  return (
    <Outlet />
  )
};
